import { Component } from 'react'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import Slider, { createSliderWithTooltip } from 'rc-slider'
import 'rc-slider/assets/index.css'
import { formatTime } from '../../../utils/secondsToDuration'

// import './Slider.web.css' // Not picked up with async imports in web-app, see web-app/src/css

const TooltipSlider = createSliderWithTooltip(Slider)

class WebSlider extends Component {
  static defaultProps = {
    onValueChange: noop,
    onSlidingStart: noop,
    onSlidingComplete: noop,
  }

  currentValue = 0

  componentWillUnmount() {
    clearTimeout(this.throttleTimeout)
  }

  setThrottleSlide = (active = false) => {
    this.throttling = active
  }

  // When clicking the progress bar onBeforeChange is called on mouse down and
  // mouse up, leaving the player in an invalid state. Throttling avoids this.
  handleBeforeChangeThrottled = () => {
    if (!this.throttling) {
      this.setThrottleSlide(true)
      this.props.onSlidingStart()
      this.throttleTimeout = setTimeout(this.setThrottleSlide, 200)
    }
  }

  handleAfterChange = () => this.props.onSlidingComplete(this.currentValue)

  formatValue = (value) => formatTime(Math.floor(value))

  render() {
    const {
      value,
      step,
      onValueChange,
      minimumValue = 0,
      maximumValue,
      onSlidingStart,
      onSlidingComplete,
      minimumTrackTintColor,
      maximumTrackTintColor,
      thumbTintColor,
      handleStyle,
      vertical,
      inverted,
      showTooltips,
      formatTooltips,
      scrubbingDisabled,
      ...props
    } = this.props
    const tipFormatter = formatTooltips ? formatTooltips : this.formatValue
    const SliderBar = showTooltips ? TooltipSlider : Slider
    return (
      <SliderBar
        {...props}
        step={step}
        min={minimumValue}
        max={Math.floor(maximumValue)} // Must be an integer
        trackStyle={{ backgroundColor: minimumTrackTintColor }}
        railStyle={{ backgroundColor: maximumTrackTintColor }}
        handleStyle={{
          borderColor: thumbTintColor,
          backgroundColor: thumbTintColor,
          ...handleStyle,
        }}
        value={value}
        onChange={(value) => {
          this.currentValue = value
          onValueChange(value)
        }}
        onBeforeChange={this.handleBeforeChangeThrottled}
        onAfterChange={this.handleAfterChange}
        tipFormatter={showTooltips && tipFormatter}
        disabled={scrubbingDisabled}
        vertical={vertical}
        reverse={inverted}
      />
    )
  }
}

WebSlider.propTypes = {
  value: PropTypes.number.isRequired,
  step: PropTypes.number,
  onValueChange: PropTypes.func.isRequired,
  minimumValue: PropTypes.number,
  maximumValue: PropTypes.number,
  onSlidingStart: PropTypes.func,
  onSlidingComplete: PropTypes.func,
  minimumTrackTintColor: PropTypes.string,
  maximumTrackTintColor: PropTypes.string,
  thumbTintColor: PropTypes.string,
  vertical: PropTypes.bool,
  inverted: PropTypes.bool,
  scrubbingDisabled: PropTypes.bool,
}

export { WebSlider as Slider }

export default WebSlider
